import React from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography } from "@material-ui/core";
import {AiFillFilePdf} from 'react-icons/ai'

const rows = [
  { description: "Disaster Management plan", pdfUrl: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Disaster_Management_plan_1.pdf" },
  { description: "Result Framework Document (RFD) for the Year 2015-2016", pdfUrl: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/rfd_15_16.pdf" },
  { description: "Status of Annual Confidential reports", pdfUrl: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/jitenpdf.pdf" },
  
  { description: "List of single window system power delegate to Urban Local bodies", pdfUrl: "https://tcp.hp.gov.in/Application/uploadDocuments/news/News20160719_105833.pdf" },
  { description: "Comparison between notifications dated 28.02.2011 and 13.08.2015 in respect of IDP,Shimla.", pdfUrl: "https://tcp.hp.gov.in/Application/uploadDocuments/news/News20150923_162616.pdf" },
  { description: "Instruction Regarding Rain Water Harvesting", pdfUrl: "https://tcp.hp.gov.in/Application/uploadDocuments/content/Instruction_Regarding_Rain_Water_Harvesting.pdf" },

  { description: "Power Delegation from Director to STP", pdfUrl: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Power_Deligation_from_Director_to_STP.pdf" },
  { description: "Innovative Proposals for Award under HP State Innovation Award Scheme for 2015-16", pdfUrl: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Innovative_Proposals_1.pdf" },
  { description: "Ease of doing Business-Online Planning and other permissions by the department of Town and Country Planning.", pdfUrl: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Ease_of_Doing_2.pdf" },

  { description: "Ease of doing business-Risk Bases Classification of Buildings.", pdfUrl: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Ease_of_Doing_.pdf" },
  { description: "Clarification regarding Constitution of District as a Region", pdfUrl: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Clarification_regarding_Region.pdf" },
  { description: "Clarification Regarding Sequences of approval by TCP, PCB and Tourism Department in case of Tourism industry", pdfUrl: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Instruction_regarding_issuance_of_Consent_to_establish_and_oprate_by_Special_SecyEnvironment.pdf" },

  { description: "Revised Policy for Setting up Mobile Communication Tower", pdfUrl: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Revised_Policy_for_Setting_UP_Mobile_Communication_Towers.pdf" },
  { description: "Instruction regarding the Uttar Pradesh Town and Country Planning (Amendment) Rules ,2020", pdfUrl: "https://tcp.hp.gov.in/Application/uploadDocuments/content/News20210215_162901.pdf" },
]

const handlePdfDownload = (pdfUrl) => {
  window.open(pdfUrl);
};

const InstructionOrders = () => {
  return (
    <React.Fragment>
    <TableContainer component={Paper}>
    <Typography variant='h6' style={{margin: '20px'}}>
      Instructions/Orders
    </Typography>
      <Table aria-label="Sample Table" style={{width: '90%', margin: '30px'}}>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.slNo}>
              <TableCell>{row.description}</TableCell>
              <TableCell onClick={() => handlePdfDownload(row.pdfUrl)}><AiFillFilePdf style={{width: '30px', height: '30px', color:'#f44b55', cursor: 'pointer' }}/></TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    </React.Fragment>
  );
};

export default InstructionOrders;
